<template>
  <div>
    <vx-drop-zone
      ref="mediaDropzone"
      :multiple="multiple"
      :max-files="maxFiles"
      :max-size="maxSize"
      :remove-button="removeButton"
      :file-types="['.csv']"
      @added="emit('added', $event)"
      @error="emit('error', $event)"
    />
    <p class="u-text-mute u-text-center u-mb-small">
      To upload, drag files to the dropzone above, or click it to select. The
      file type must be <b>CSV</b> and not exceed
      <b>{{ formatBytes(maxSize) }}</b> or <b>{{ formatNumber(maxRows) }}</b> rows.
    </p>
  </div>
</template>
<script setup>
import { VxDropZone } from '@voxie/frontend-components-v3';
import { ref } from 'vue';

defineProps({
  multiple: {
    type: Boolean,
    default: false,
  },
  maxFiles: {
    type: Number,
    default: 1,
  },
  maxSize: {
    type: Number,
    default: 200000000,
  },
  maxRows: {
    type: Number,
    default: 1000000,
  },
  removeButton: {
    type: Boolean,
    default: false,
  },
});

const mediaDropzone = ref();

// Methods
const emit = defineEmits(["added", "error"]);

const removeFile = (file) => {
  mediaDropzone.value.removeFile(file);
}

const updateProgress = (file, progress) => {
  mediaDropzone.value.updateProgress(file, progress);
}

const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) {
        return '0 bytes';
    }

    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [' bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}

const formatNumber = (number) => {
    return Intl.NumberFormat('en-US').format(number);
}

defineExpose({
  removeFile,
  updateProgress
});

</script>
